export default class AppConst {
    static GLOBALS = {
        initUrl: "/endpoint/auth/init",
        enabledFunctionsUrl: "/endpoint/enabled-functions/get",
        loginUrl: "/endpoint/auth/login",
        logoutUrl: "/endpoint/auth/logout",
        forgotPasswordUrl: "/endpoint/auth/forgot-password",
        registerUrl: "/endpoint/auth/register",
        existentFieldUrl: "/endpoint/auth/existent-field",
        saveAircraftListingUrl: "/endpoint/aircraft-listing/add",
        saveAircraftRentalUrl: "/endpoint/aircraft-rental/add",
        saveAircraftPartUrl: "/endpoint/aircraft-part/add",
        saveExperienceUrl: "/endpoint/experience/add",
        getAircraftListingUrl: "/endpoint/aircraft-listing/get",
        getAircraftListingDetailsUrl: "/endpoint/aircraft-listing/get-details",
        getAircraftRentalUrl: "/endpoint/aircraft-rental/get",
        getAircraftRentalDetailsUrl: "/endpoint/aircraft-rental/get-details",
        getAircraftPartUrl: "/endpoint/aircraft-part/get",
        getAircraftPartDetailsUrl: "/endpoint/aircraft-part/get-details",
        getExperienceUrl: "/endpoint/experience/get",
        getExperienceDetailsUrl: "/endpoint/experience/get-details",
        getAllAircraftListingsUrl: "/endpoint/aircraft-listing/get-all",
        getAllAircraftRentalsUrl: "/endpoint/aircraft-rental/get-all",
        getAllAircraftPartsUrl: "/endpoint/aircraft-part/get-all",
        getAllExperiencesUrl: "/endpoint/experience/get-all",
        addBookingsUrl: "/endpoint/booking/add",
        requestAircraftRentalBookingUrl: "/endpoint/rental-booking/request",
        requestExperienceBookingUrl: "/endpoint/experience-booking/request",
        getCartUrl: "/endpoint/cart/get",
        removeCartItemUrl: "/endpoint/cart/removeItem",
        addToCart: "/endpoint/cart/addItem",
        getMyListingsUrl: "/endpoint/aircraft-listing/get-my",
        getMyRentalsUrl: "/endpoint/aircraft-rental/get-my",
        getMyPartsUrl: "/endpoint/aircraft-part/get-my",
        getMyExperiencesUrl: "/endpoint/experience/get-my",
        updateAircraftListingUrl: "/endpoint/aircraft-listing/update",
        updateAircraftRentalUrl: "/endpoint/aircraft-rental/update",
        updateAircraftPartUrl: "/endpoint/aircraft-part/update",
        updateExperienceUrl: "/endpoint/experience/update",
        requestViewingUrl: "/endpoint/aircraft-listing/request-viewing",
        processCardPaymentUrl: "/card/processPayment",
        configureSellerAccountUrl: "/endpoint/user/configure",
        validateIbanUrl: "endpoint/configure/validate-iban",
        validateVatIdUrl: "endpoint/configure/validate-vatId",
        updateUserAccountUrl: "/endpoint/user/update",
        termsConditionsUrl: "/endpoint/terms-conditions/get",
        getCommissionRatesUrl: "/endpoint/commission-rate/get",
        getListingPlansUrl: "/endpoint/listing-plan/get",
        toggleAircraftActiveStateUrl: "/endpoint/aircraft-listing/toggle-active-state",
        toggleRentalActiveStateUrl: "/endpoint/aircraft-rental/toggle-active-state",
        togglePartActiveStateUrl: "/endpoint/part/toggle-active-state",
        toggleExperienceActiveStateUrl: "/endpoint/experience/toggle-active-state",
        getDictionaryUrl: "/endpoint/dictionary/get",
        getAppConfigMapUrl: "/endpoint/app-config/get",
        getMyOrdersUrl: "/endpoint/order/get-my",
        getPublicAircraftListingsCountUrl: "/endpoint/aircraft-listing/get-count",
        getPublicAircraftRentalsCountUrl: "/endpoint/aircraft-rental/get-count",
        getPublicAircraftPartsCountUrl: "/endpoint/aircraft-part/get-count",
        getPublicExperiencesCountUrl: "/endpoint/experience/get-count",
        aiQueryUrl: "/endpoint/ai/query",
    };

    static LOGIN_INIT = {};
    static LOGOUT_INIT = {};

    static API_AUTH_TOKEN = "6d5b75d8-631e-11f0-bc77-a7118d0077c0";
    static AtJST = "_AtJST";
    static AtST = "_AtST";

    static cookiePath="/";
    static cookieDomain="localhost";
    static cookieSameSite ="";
    static cookieSecure=false;

    static msgDuration = 2;

    static webappName = null;
    static webappVersion = null;
    static isLoggedIn = false;
    static username = null;

    static countries = [
      { name: "Albania", code: "AL", flag: "🇦🇱", prefix: "+355", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Andorra", code: "AD", flag: "🇦🇩", prefix: "+376", regex: /^\d{6}$/, placeholder: "000 000" },
      { name: "Austria", code: "AT", flag: "🇦🇹", prefix: "+43", regex: /^\d{4,13}$/, placeholder: "0000 0000 0000" },
      { name: "Belarus", code: "BY", flag: "🇧🇾", prefix: "+375", regex: /^\d{9,10}$/, placeholder: "000 000 0000" },
      { name: "Belgium", code: "BE", flag: "🇧🇪", prefix: "+32", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Bosnia and Herzegovina", code: "BA", flag: "🇧🇦", prefix: "+387", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Bulgaria", code: "BG", flag: "🇧🇬", prefix: "+359", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Croatia", code: "HR", flag: "🇭🇷", prefix: "+385", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Cyprus", code: "CY", flag: "🇨🇾", prefix: "+357", regex: /^\d{8}$/, placeholder: "0000 0000" },
      { name: "Czech Republic", code: "CZ", flag: "🇨🇿", prefix: "+420", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "Denmark", code: "DK", flag: "🇩🇰", prefix: "+45", regex: /^\d{8}$/, placeholder: "00 00 00 00" },
      { name: "Estonia", code: "EE", flag: "🇪🇪", prefix: "+372", regex: /^\d{7,8}$/, placeholder: "0000 0000" },
      { name: "Finland", code: "FI", flag: "🇫🇮", prefix: "+358", regex: /^\d{7,10}$/, placeholder: "000 000 0000" },
      { name: "France", code: "FR", flag: "🇫🇷", prefix: "+33", regex: /^\d{9}$/, placeholder: "0 00 00 00 00" },
      { name: "Germany", code: "DE", flag: "🇩🇪", prefix: "+49", regex: /^\d{7,11}$/, placeholder: "0000 0000000" },
      { name: "Greece", code: "GR", flag: "🇬🇷", prefix: "+30", regex: /^\d{10}$/, placeholder: "000 000 0000" },
      { name: "Hungary", code: "HU", flag: "🇭🇺", prefix: "+36", regex: /^\d{6,9}$/, placeholder: "000 000 000" },
      { name: "Iceland", code: "IS", flag: "🇮🇸", prefix: "+354", regex: /^\d{7}$/, placeholder: "000 0000" },
      { name: "Ireland", code: "IE", flag: "🇮🇪", prefix: "+353", regex: /^\d{7,9}$/, placeholder: "000 000 000" },
      { name: "Italy", code: "IT", flag: "🇮🇹", prefix: "+39", regex: /^\d{8,10}$/, placeholder: "000 000 0000" },
      { name: "Latvia", code: "LV", flag: "🇱🇻", prefix: "+371", regex: /^\d{8}$/, placeholder: "0000 0000" },
      { name: "Liechtenstein", code: "LI", flag: "🇱🇮", prefix: "+423", regex: /^\d{7}$/, placeholder: "000 0000" },
      { name: "Lithuania", code: "LT", flag: "🇱🇹", prefix: "+370", regex: /^\d{8}$/, placeholder: "0000 0000" },
      { name: "Luxembourg", code: "LU", flag: "🇱🇺", prefix: "+352", regex: /^\d{8}$/, placeholder: "00 00 00 00" },
      { name: "Malta", code: "MT", flag: "🇲🇹", prefix: "+356", regex: /^\d{8}$/, placeholder: "0000 0000" },
      { name: "Moldova", code: "MD", flag: "🇲🇩", prefix: "+373", regex: /^\d{8}$/, placeholder: "0000 0000" },
      { name: "Monaco", code: "MC", flag: "🇲🇨", prefix: "+377", regex: /^\d{8}$/, placeholder: "0000 0000" },
      { name: "Netherlands", code: "NL", flag: "🇳🇱", prefix: "+31", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "Norway", code: "NO", flag: "🇳🇴", prefix: "+47", regex: /^\d{8}$/, placeholder: "00 00 00 00" },
      { name: "Poland", code: "PL", flag: "🇵🇱", prefix: "+48", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "Portugal", code: "PT", flag: "🇵🇹", prefix: "+351", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "Romania", code: "RO", flag: "🇷🇴", prefix: "+40", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "San Marino", code: "SM", flag: "🇸🇲", prefix: "+378", regex: /^\d{6}$/, placeholder: "000 000" },
      { name: "Serbia", code: "RS", flag: "🇷🇸", prefix: "+381", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Slovakia", code: "SK", flag: "🇸🇰", prefix: "+421", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "Slovenia", code: "SI", flag: "🇸🇮", prefix: "+386", regex: /^\d{8,9}$/, placeholder: "000 000 000" },
      { name: "Spain", code: "ES", flag: "🇪🇸", prefix: "+34", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "Sweden", code: "SE", flag: "🇸🇪", prefix: "+46", regex: /^\d{7,10}$/, placeholder: "000 000 0000" },
      { name: "Switzerland", code: "CH", flag: "🇨🇭", prefix: "+41", regex: /^\d{9}$/, placeholder: "000 000 000" },
      { name: "United Kingdom", code: "GB", flag: "🇬🇧", prefix: "+44", regex: /^\d{10}$/, placeholder: "000 000 0000" }
    ];

    static readonly BookingState = {
            AVAILABLE: "AVAILABLE",
            PENDING: "PENDING",
            BOOKED: "BOOKED",
            MAINTENANCE: "MAINTENANCE"
        } as const;

    static CONTENT = {
            step1: "Pasul 01",
            step2: "Pasul 02",
            step3: "Pasul 03",
            step1Title: "Data misiunii",
            step2Title: "Timeline",
            step2UTC: "/ UTC+2",
            step3Title: "Scopul misiunii",
            purposePlaceholder: "Specificați scopul zborului...",
            rentalUnit: "Unitatea de închiriat",
            date: "Data misiunii",
            startTime: "Ora estimată pornire",
            duration: "Durata misiunii",
            purpose: "Scop misiune",
            price: "Cost operațional estimat",
            currency: "EUR",
            button: "Trimite cererea",
        };
}